import styled from "styled-components";
import { CheckBoxWithContent } from "uikit";

const Root = styled(CheckBoxWithContent)`
	margin-left: 4px;
`;

export default Root;
